<template>
  <main>
    <div class="page-area">
      <div class="breadcumb-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="breadcrumb text-center">
              <div class="section-headline white-headline">
                <h3>关于星瀛科技</h3>
              </div>
              <!-- <ul class="breadcrumb-bg">
                <li class="home-bread">支持</li>
                <li>关于星瀛科技</li>
              </ul>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End breadcumb Area -->
    <div class="about-area bg-color-2 area-padding u-coment">
      <ul class="container">
        <li>
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;星瀛科技（北京）有限公司是由一群热爱互联网的极客创建，该团队长期从事云计算机软件开发、运营工作，是国内该领域的顶尖精英。仅在短短两年内，就荣获了中国信通院颁发的“优秀云游戏平台”“最佳云游戏行业应用”等多个称号，并通过了十多项软件著作权，进阶成“中关村新高技术企业”。</span
            >
            <br />
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >通过搭建高性能的海星云电脑，为传统PC、移动手机、客厅电视、VR等多客户端用户提供了软硬件综合解决方案。从此踏上了通向未来5G时代的星域征途。
            星瀛科技的征途是星辰大海，而他们的团队向往的正是那“手握方寸须弥界，4K高清任逍遥”的胜境。
            公司团队由热爱信息技术的硬核玩家组建，秉持互联网、云计算和5G产业的深刻见解，洞察科技产业未来发展与业务创新方向，为用户用户提供高性能、高服务、低延迟的使用体验。
            <br />
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;星瀛科技未来将积极整资源，充分优化软件与平台架构，持续改善用户体验，为商业生态与合作伙伴创造新的价值与增长模式，深度融入5G时代新应用产业的发展与繁荣。</span
            >
          </p>
        </li>
      </ul>
    </div>
    <!-- 全局qq和微信联系方式 index中有全局 -->
    <div class="hotline">
      <i class="fa fa-qq link"></i>
      <div class="qrcode-div">
        <img
          draggable="false"
          class="image"
          style="width: 100%; height: 100%"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/qqCode.png`"
        />
      </div>
    </div>
    <div class="hotline2">
      <i class="fa fa-wechat link-wechat"></i>
      <div class="qrcode-div2">
        <img
          class="image"
          draggable="false"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/Wechat2.jpg`"
        />
      </div>
    </div>
    <!-- End About Area -->
    <!-- about-area start -->

    <!-- about-area end -->
    <!-- Team area start -->
    <!-- <div class="team-area bg-color-1 area-padding-2">
      <div class="container">

        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="section-headline white-headline text-center">
              <h3>Our Experts</h3>
              <p>Cavalier Studios has been creating innovative games since 2003. We offer our clients professional development services.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="team-member text-center">

            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="single-member">
                <div class="team-img">
                  <a >
                    <img src="../assets/new/img/team/t1.jpg" alt />
                  </a>
                </div>
                <div class="team-content">
                  <h4>
                    <a >Hamilton</a>
                  </h4>
                  <p>Games Developer</p>
                  <ul class="team-hover">
                    <li>
                      <a >
                        <i class="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="single-member">
                <div class="team-img">
                  <a >
                    <img src="../assets/new/img/team/t2.jpg" alt />
                  </a>
                </div>
                <div class="team-content">
                  <h4>
                    <a >Mickhel</a>
                  </h4>
                  <p>Games Designer</p>
                  <ul class="team-hover">
                    <li>
                      <a >
                        <i class="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="single-member">
                <div class="team-img">
                  <a >
                    <img src="../assets/new/img/team/t3.jpg" alt />
                  </a>
                </div>
                <div class="team-content">
                  <h4>
                    <a >Arnold</a>
                  </h4>
                  <p>Games developer</p>
                  <ul class="team-hover">
                    <li>
                      <a >
                        <i class="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="single-member">
                <div class="team-img">
                  <a >
                    <img src="../assets/new/img/team/t4.jpg" alt />
                  </a>
                </div>
                <div class="team-content">
                  <h4>
                    <a >Gonjamul</a>
                  </h4>
                  <p>Social marketer</p>
                  <ul class="team-hover">
                    <li>
                      <a >
                        <i class="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>-->
    <!-- team area end -->
    <!-- Start Brand Area -->
    <!-- <div class="brand-area bg-color-2 area-padding">
      <div class="container">
        <div class="row">
          <div class="brand-items">
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/1.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/2.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/3.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/4.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/5.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/6.png" alt />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!-- end Brand Area -->
    <!-- Start Challange Area -->
    <!-- <div class="challange-area bg-color-1 area-padding">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="section-headline white-headline text-center">
              <h3>Competition</h3>
              <p>Cavalier Studios has been creating innovative games since 2003. We offer our clients professional development services.</p>
            </div>
          </div>
        </div>
        <div class="row">

          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="tab-menu">

              <ul class="nav nav-tabs" role="tablist">
                <li class="active">
                  <a href="#p-view-1" role="tab" data-toggle="tab">
                    <img class="cha-img" src="../assets/new/img/challange/c1.jpg" alt="challange image" />
                    <span class="title-date">
                      <span class="cha-title">Challanger fight competition</span>
                      <span class="cha-date">September 05, 2018</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#p-view-2" role="tab" data-toggle="tab">
                    <img class="cha-img" src="../assets/new/img/challange/c2.jpg" alt="challange image" />
                    <span class="title-date">
                      <span class="cha-title">Temple Fight Challanger</span>
                      <span class="cha-date">December 01, 2018</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#p-view-3" role="tab" data-toggle="tab">
                    <img class="cha-img" src="../assets/new/img/challange/c3.jpg" alt="challange image" />
                    <span class="title-date">
                      <span class="cha-title">Angels fight competition</span>
                      <span class="cha-date">November 12, 2018</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#p-view-4" role="tab" data-toggle="tab">
                    <img class="cha-img" src="../assets/new/img/challange/b4.jpg" alt="challange image" />
                    <span class="title-date">
                      <span class="cha-title">Dangers War fight man</span>
                      <span class="cha-date">September 20, 2018</span>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="tab-content">
              <div class="tab-pane active" id="p-view-1">
                <div class="tab-inner">
                  <div class="single-page">
                    <div class="page-img">
                      <img src="../assets/new/img/challange/b1.jpg" alt />
                    </div>
                    <a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play">
                      <i class="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="p-view-2">
                <div class="tab-inner">
                  <div class="single-page">
                    <div class="page-img">
                      <img src="../assets/new/img/challange/b2.jpg" alt />
                    </div>
                    <a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play">
                      <i class="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="p-view-3">
                <div class="tab-inner">
                  <div class="single-page">
                    <div class="page-img">
                      <img src="../assets/new/img/challange/b3.jpg" alt />
                    </div>
                    <a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play">
                      <i class="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="p-view-4">
                <div class="tab-inner">
                  <div class="single-page">
                    <div class="page-img">
                      <img src="../assets/new/img/challange/b4.jpg" alt />
                    </div>
                    <a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play">
                      <i class="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>-->
  </main>
</template>
<script>
export default {
  metaInfo: {
    title:
      '海星云-关于我们-星瀛科技',
    meta: [
      {
        name: 'keywords',
        content:
          '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content:
          '公司团队由热爱信息技术的硬核玩家组建，秉持互联网、云计算和5G产业的深刻见解，洞察科技产业未来发展与业务创新方向，为玩家用户提供高性能、高服务、低延迟游戏体验。'
      }
    ]
  }
}
</script>
 <style  lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/aboutxy_details.vue